import { Dialog, DialogContent } from "@component/dialog";
import { AlertTriangleIcon } from "lucide-react";

interface BYOCDomainPopupProps {
    isOpen: boolean;
    onClose: () => void;
    userEmail?: string;
}

export default function BYOCDomainRegisterPopup({
    isOpen,
    onClose,
    userEmail,
}: BYOCDomainPopupProps) {

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md">
                <div className="flex flex-col items-center text-center space-y-6 py-6">
                    {/* Icon */}
                    <div className="w-16 h-16 bg-yellow-100 dark:bg-yellow-900/20 rounded-full flex items-center justify-center">
                        <AlertTriangleIcon className="w-8 h-8 text-yellow-600 dark:text-yellow-400" />
                    </div>

                    {/* Title */}
                    <div className="space-y-2">
                        <h2 className="text-xl font-semibold text-foreground">
                            Incorrect Registration Portal
                        </h2>
                        <p className="text-sm text-muted-foreground max-w-sm">
                            Your email ({userEmail}) does not match this company’s domain. To continue, please ensure that you use your company email or the correct registration link.
                        </p>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
}
